var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNotify } from '../../hooks/notificationHook';
var FobPriceField = styled(TextField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiInputBase-input {\n    text-align: right;\n  }\n"], ["\n  .MuiInputBase-input {\n    text-align: right;\n  }\n"])));
var BidFobPriceField = function (_a) {
    var offer = _a.offer, onChange = _a.onChange, value = _a.value, _b = _a.offerFobPrice, offerFobPrice = _b === void 0 ? Number(offer.fobPrice) : _b;
    var t = useTranslation().t;
    var _c = React.useState(offerFobPrice), currentValue = _c[0], setCurrentValue = _c[1];
    var notify = useNotify();
    React.useEffect(function () {
        setCurrentValue(value || '');
    }, [value]);
    var handleBlur = React.useCallback(function (ev) {
        if (ev.target.value === '') {
            setCurrentValue('');
            onChange(undefined);
            return;
        }
        var value = parseFloat(ev.target.value);
        if (Number.isNaN(value) || value < offerFobPrice) {
            value = offerFobPrice;
            notify('error', [t('errors.lowestBidFobPriceError')]);
        }
        setCurrentValue(value);
        onChange(value);
    }, [onChange, offer, t, notify]);
    var handleChange = React.useCallback(function (ev) {
        setCurrentValue(ev.target.value);
    }, []);
    return (React.createElement(FobPriceField, { type: "number", size: "small", variant: "outlined", onBlur: handleBlur, value: currentValue, onChange: handleChange, placeholder: offerFobPrice.toString(), inputProps: { step: 0.01, 'aria-label': 'FOB Price' } }));
};
export default BidFobPriceField;
var templateObject_1;
